// 组件对象，大写
import readTextNotUseVModel from './readTextNotUseVModel.vue'
export default readTextNotUseVModel
